import axios from 'axios';
import config from '@assets/config.json'; // api 请求json 

const state = {
}
const mutations = {
}
const getters = {
}
const actions = { 
  applyOMGetAll ({ rootState }, opt) { // 获取绑定时的展会列表
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/ApplyOM/GetAll`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  applyOMGetTotal ({ rootState }, opt) { // 统计展会下各展区面积数量
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/ApplyOM/GetTotal`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  applyOMGetApplyCompany ({ rootState }, opt) { // 统计展会下各展区展商详情
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/ApplyOM/GetApplyCompany`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  applyOMAllApplyCompanyByExhibitionId ({ rootState }, opt) { // 统计展会下各展区展商详情
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/ApplyOM/AllApplyCompanyByExhibitionId`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  applyOMGetById ({ rootState }, opt) { // 获取单条数据
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/ApplyOM/GetById?ExhibitionId=${opt.exhibitionId}&DePjNameGroupId=${opt.dePjNameGroupId}&ApplyCompanyId=${opt.applyCompanyId}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
} 